import React from 'react';
import CareCertified from 'assets/icons/center-certified.svg';
import { Text, Colors } from 'library';

export default function CenterCertifiedBanner() {
    return (
        <div
            style={{
                backgroundColor: Colors.lightGrey,
                borderRadius: 30,
                padding: 8,
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'center',
                marginBottom: 8,
            }}
        >
            <CareCertified style={{ width: 32, height: 32, marginRight: 8 }} />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Text variant="body2" bold>
                    Pending Care Certification
                </Text>
                <Text variant="caption">
                    Est. start date <b>2 weeks</b>
                </Text>
            </div>
        </div>
    );
}
